import { Container } from '@mantine/core'
import type { MetaFunction } from '@remix-run/node'
import { generateMetaDescriptor } from '~/core/shared/utils/misc'

export const meta: MetaFunction = (meta) =>
  generateMetaDescriptor(meta, { pageTitle: '就活生様向けお問い合わせ' })

export const handle = {
  breadcrumb: () => {
    return [
      {
        id: 'contact-student',
        title: '就活生様向けお問い合わせ',
      },
    ]
  },
}

export default function ContactStudent() {
  return (
    <Container>
      <iframe
        title='問い合わせ'
        src='https://airtable.com/embed/appzBvR0KuOV7FQeX/pagO2xE3EQdq2Qqzg/form'
        width='100%'
        height='1000'
        style={{ background: 'transparent', border: '0' }}
      />
    </Container>
  )
}
